// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import React from 'react';
import PlusOutlinedSvg from "@ant-design/icons-svg/es/asn/PlusOutlined";
import AntdIcon from '../components/AntdIcon';

var PlusOutlined = function PlusOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlusOutlinedSvg
  }));
};

PlusOutlined.displayName = 'PlusOutlined';
export default React.forwardRef(PlusOutlined);